import { ShowAllData } from '@/apiError/apiShow';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { API } from '@/api/config';
import { showToast } from '@/utils/toastMessage/ToastMessage';

export const useControlSettings = (navigate) => {
  return useQuery({
    queryKey: ['controlSettings'],
    staleTime: 0,
    queryFn: async () =>
      await ShowAllData.showDetails('/superadmin/control-settings/', navigate),
  });
};

export const useUpdateControlSettings = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (value) =>
      await API.patch(
        `/superadmin/control-settings/${value.referenceId}/`,
        value,
      ),
    onSuccess: async () => {
      // await queryClient.invalidateQueries({
      //   queryKey: ['controlSettings'],
      //   exact: true,
      // });
      showToast('Control Settings Updated Successfully', 'success');
    },
    onError: (error) => {
      console.error('Mutation failed', error);
      showToast('Failed to update Control Settings', 'error');
    },
  });
};

export const useCreateControlSettings = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (value) =>
      await API.post('/superadmin/control-settings/', value),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['controlSettings'] });
    },
  });
};

export const useDeleteControlSettings = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id) => {
      const { data } = await API.delete(`/superadmin/control-settings/${id}/`);

      if (data.ResponseCode == '0') {
        queryClient.invalidateQueries({ queryKey: ['controlSettings'] });
      }

      return data;
    },
  });
};
